import { useNavigate, useParams } from "react-router-dom";
import HeaderComponent from "../../../components/header";
import ContainerComponent from "../../../components/conatiner";
import CardHeaderBackgroundComponent from "../../../components/cardHeaderBackground";
import InputComponent from "../../../components/input";
import { ChangeEvent, useEffect, useState } from "react";
import { ManagersEmployeesCostCenterService } from "../../../services/managers/employees";
import { ToastErro, ToastSucesso } from "../../../components/toast";
import TableComponent from "../../../components/table";
import { IUser } from "../../../types";
import { ManagersCostCenterAddEmployeeService, ManagersCostCenterRemoveEmployeeService, ManagersCostCentersEmployeesNotRegisteredService } from "../../../services/managers/cost_centers";
import ModalComponent from "../../../components/modal";
import { Autocomplete, Checkbox, TextField } from "@mui/material";

const ManagersCostCenterEmployeesPage = () => {

    const navigate = useNavigate();

    const { id } = useParams();

    const [loading, setLoading] = useState<boolean>(true);

    const [employeesNotRegistered, setEmployeesNotRegistered] = useState<any>([]);
    const [employees, setEmployees] = useState<any>(null)

    const [employeesToAdd, setEmployeesToAdd] = useState<Array<any>>([]);

    const [name, setName] = useState<string>('');
    const [page, setPage] = useState<number>(1);

    const getEmployees = async () => {

        setLoading(true);

        await ManagersEmployeesCostCenterService(parseInt(id!), name, page).then(resp => {
            setEmployees(resp.data);
        }).catch(error => {
            ToastErro(error?.response?.data?.message);
        });

        setLoading(false);

    }

    const getEmployeesNotRegistered = async () => {
        await ManagersCostCentersEmployeesNotRegisteredService(parseInt(id!)).then(resp => {
            setEmployeesNotRegistered(resp.data);
        });
    }

    const addEmployees = async () => {

        if (employeesToAdd.length < 1) {
            ToastErro('Selecione no mínimo 1 funcionário!');
            return;
        }

        (window as any).$("#modalAddEmployee").modal('hide');

        let formatEmployees: number[] = [];

        employeesToAdd.map((e: any) => {
            formatEmployees.push(e.id);
        });

        setLoading(true);

        await ManagersCostCenterAddEmployeeService(parseInt(id!), JSON.stringify(formatEmployees)).then(resp => {
            setEmployeesToAdd([]);
            ToastSucesso(resp.data.message);
            getEmployeesNotRegistered();
            setTimeout(() => {
                getEmployees();
            }, 1000)
        });

    }

    const removeUser = async (userId: number) => {

        (window as any).$("#modalRemove" + userId).modal("hide");

        setLoading(true);

        await ManagersCostCenterRemoveEmployeeService(parseInt(id!), userId).then(resp => {
            ToastSucesso(resp.data.message);
            getEmployeesNotRegistered();
            setTimeout(() => {
                getEmployees();
            }, 1000)
        });

    }

    useEffect(() => {
        getEmployeesNotRegistered();
    }, []);

    useEffect(() => {
        getEmployees();
    }, [page]);

    return (
        <>
            <HeaderComponent
                title="Funcionários"
                button="Voltar"
                iconButton="arrow_back"
                onClick={() => navigate('/managers/cost_centers')}
                button2="Adicionar"
                iconButton2="add"
                onClick2={() => (window as any).$("#modalAddEmployee").modal('show')}                
            />
            <ContainerComponent>
                <>
                    <CardHeaderBackgroundComponent
                        title="Pesquisar"
                    >
                        <div className="row">
                            <InputComponent
                                label="Nome"
                                col={8}
                                size={'small'}
                                defaultValue={name}
                                onChange={(e: ChangeEvent<HTMLInputElement>) => setName(e.target.value)}
                            />
                            <div className="col">
                                <button className="btn btn-primary" type="button" onClick={getEmployees}>Pesquisar</button>
                                <button className="btn btn-danger mx-2" type="button" onClick={() => (window as any).location.reload()}>Limpar</button>
                            </div>
                        </div>
                    </CardHeaderBackgroundComponent>

                    <TableComponent
                        columns={['ID', 'Nome', 'CPF', 'Remover']}
                        loading={loading}
                        title="Funcionários"
                        page={page}
                        onClickPagination={(event: unknown, newPage: number) => setPage(newPage)}
                        last_page={employees?.last_page}
                    >
                        {
                            employees?.data?.map((employee: any) => {
                                return (
                                    <tr key={employee.id}>
                                        <td className="px-4">{employee.id}</td>
                                        <td className="px-4">{employee.name}</td>
                                        <td className="px-4">{employee.cpf}</td>
                                        <td className="px-4">
                                            <button className="btn btn-text-danger" type="button" title="Remover" onClick={() => (window as any).$("#modalRemove" + employee.id).modal("show")}><i className="material-icons">delete</i></button>
                                            <ModalComponent
                                                title="Remover Funcionário"
                                                id={`modalRemove${employee.id}`}
                                            >
                                                <>
                                                    <p>Você tem certeza que deseja remover este funcionario?</p>
                                                    <div className="d-flex justify-content-end mt-4">
                                                        <button className="btn btn-primary" type="button" onClick={() => removeUser(employee.id)}>Remover</button>
                                                    </div>
                                                </>
                                            </ModalComponent>
                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </TableComponent>
                </>
            </ContainerComponent>

            <ModalComponent
                title="Adicionar Funcionários"
                id="modalAddEmployee"
            >
                <>
                    <div className="row mt-3 mb-4">
                        <div className="col-md-12">
                            <Autocomplete
                                multiple
                                options={employeesNotRegistered}
                                disableCloseOnSelect
                                getOptionLabel={(option: any) => option.id + ' - ' + option.name}
                                renderOption={(props, option, { selected }) => (
                                    <li {...props}>
                                        <Checkbox
                                            style={{ marginRight: 8 }}
                                            checked={selected}
                                        />
                                        {option.name}
                                    </li>
                                )}
                                className="w-100"
                                renderInput={(params) => (
                                    <TextField {...params} label="Funcionários" placeholder="Pesquisar" />
                                )}
                                value={employeesToAdd}
                                onChange={(event: any, newValue: any) => {
                                    setEmployeesToAdd(newValue);
                                }}
                            />
                        </div>
                    </div>
                    <div className="d-flex justify-content-end mt-4">
                        <button className="btn btn-primary" type="button" onClick={addEmployees}>Salvar</button>
                    </div>
                </>
            </ModalComponent>
        </>
    );

}

export default ManagersCostCenterEmployeesPage;